import { QueryConfig } from "store/utils/query-config";

export const bookingActivityLogsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-timestamp"],
  },
};

export function bookingActivityLogsQueryForBooking(
  bookingId: string
): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["-timestamp"] },
  };
}
